import styled          from 'styled-components';

import { cssFlexRow,
         themeColors } from 'src/providers/theme/shared';



type IconButtonLookAndFeel = {
  iconColor: string;
  selectedIconColor: string;
  disabledIconColor: string;
  borderColor?: string;
  selectedBorderColor?: string;
  disabledBorderColor?: string;
  dotColor: string;

  dotPadding: number;

  buttonSize: number;
  iconSize: number;
  dotSize: number;
};

const iconbutton_s48bluered: IconButtonLookAndFeel = {
  iconColor: themeColors.AccentBlue2,
  selectedIconColor: themeColors.AccentRed1,
  disabledIconColor: themeColors.SecondaryGray5,
  dotColor: themeColors.AccentRed1,

  dotPadding: 5,

  buttonSize: 48,
  iconSize: 24,
  dotSize: 8,
}

const iconbutton_s48redred: IconButtonLookAndFeel = {
  iconColor: themeColors.AccentRed1,
  selectedIconColor: themeColors.AccentRed1,
  disabledIconColor: themeColors.SecondaryGray5,
  dotColor: themeColors.AccentRed1,

  dotPadding: 5,

  buttonSize: 48,
  iconSize: 24,
  dotSize: 8,
}

const iconbutton_s46bluered: IconButtonLookAndFeel = {
  iconColor: themeColors.AccentBlue2,
  selectedIconColor: themeColors.AccentRed1,
  disabledIconColor: themeColors.SecondaryGray5,
  dotColor: themeColors.AccentRed1,

  dotPadding: 5,

  buttonSize: 46,
  iconSize: 24,
  dotSize: 8,
}

const iconbutton_s22bluered: IconButtonLookAndFeel = {
  iconColor: themeColors.AccentBlue2,
  selectedIconColor: themeColors.AccentRed1,
  disabledIconColor: themeColors.SecondaryGray5,
  dotColor: themeColors.AccentRed1,

  dotPadding: 3,

  buttonSize: 22,
  iconSize: 16,
  dotSize: 3,
}

const iconbutton_s17grayred: IconButtonLookAndFeel = {
  iconColor: themeColors.SecondaryGray4,
  selectedIconColor: themeColors.AccentRed1,
  disabledIconColor: themeColors.SecondaryGray2,
  dotColor: themeColors.AccentRed1,

  dotPadding: 3,

  buttonSize: 17,
  iconSize: 15,
  dotSize: 3,
}

const iconbutton_s44gray4red: IconButtonLookAndFeel = {
  iconColor: themeColors.SecondaryGray4,
  selectedIconColor: themeColors.AccentRed1,
  disabledIconColor: themeColors.SecondaryGray5,
  dotColor: themeColors.AccentRed1,

  dotPadding: 5,

  buttonSize: 44,
  iconSize: 24,
  dotSize: 8,
}


const iconbutton_s48whitered: IconButtonLookAndFeel = {
  iconColor: themeColors.PrimaryWhite,
  selectedIconColor: themeColors.AccentRed1,
  disabledIconColor: themeColors.SecondaryGray5,
  dotColor: themeColors.AccentRed1,

  dotPadding: 5,

  buttonSize: 48,
  iconSize: 24,
  dotSize: 8,
}

const iconbutton_s36redblue: IconButtonLookAndFeel = {
  iconColor: themeColors.AccentRed1,
  selectedIconColor: themeColors.AccentRed1,
  disabledIconColor: themeColors.SecondaryGray5,
  dotColor: themeColors.AccentBlue2,

  dotPadding: 5,

  buttonSize: 36,
  iconSize: 24,
  dotSize: 8,
}

const iconbutton_s32clear: IconButtonLookAndFeel = {
  iconColor: themeColors.PrimaryBlack,
  selectedIconColor: themeColors.AccentRed1,
  disabledIconColor: themeColors.SecondaryGray5,
  dotColor: themeColors.AccentPrimaryBlueCobolt01,

  dotPadding: 0,

  buttonSize: 32,
  iconSize: 24,
  dotSize: 8,
}

const iconbutton_s36black: IconButtonLookAndFeel = {
  iconColor: themeColors.PrimaryBlack,
  selectedIconColor: themeColors.PrimaryBlack,
  disabledIconColor: themeColors.SecondaryGray5,
  dotColor: themeColors.AccentPrimaryBlueCobolt01,

  dotPadding: 0,

  buttonSize: 36,
  iconSize: 24,
  dotSize: 6,
}

const iconbutton_s48outlined: IconButtonLookAndFeel = {
  iconColor: themeColors.AccentPrimaryBlueCobolt01,
  selectedIconColor: themeColors.AccentRed1,
  disabledIconColor: themeColors.SecondaryGray5,
  borderColor: themeColors.BorderPastelBluePrimary2,
  selectedBorderColor: themeColors.AccentRed1,
  disabledBorderColor: themeColors.SecondaryGray5,
  dotColor: themeColors.AccentRed1,

  dotPadding: 5,

  buttonSize: 48,
  iconSize: 24,
  dotSize: 8,
}

const iconbutton_s48outlinedRed: IconButtonLookAndFeel = {
  ...iconbutton_s48outlined,
  iconColor: themeColors.AccentRed1,
  selectedIconColor: themeColors.AccentRed1,
}

const iconbutton_s48black: IconButtonLookAndFeel = {
  iconColor: themeColors.PrimaryBlack,
  selectedIconColor: themeColors.PrimaryBlack,
  disabledIconColor: themeColors.SecondaryGray5,
  dotColor: themeColors.AccentRed1,

  dotPadding: 5,

  buttonSize: 48,
  iconSize: 24,
  dotSize: 8,
}

export type IconButtonVariants = 's48bluered' | 's46bluered' | 's22bluered' | 's17grayred' | 's48whitered' | 's44gray4red' | 's36redblue' | 's48redred' | 's32clear' |
                                's36black' |
                                's48outlined' | 's48outlinedRed' |
                                's48black';

export const iconbutton_variants: Map<IconButtonVariants, IconButtonLookAndFeel> = 
  new Map<IconButtonVariants, IconButtonLookAndFeel>([
    ['s48bluered', iconbutton_s48bluered],
    ['s46bluered', iconbutton_s46bluered],
    ['s22bluered', iconbutton_s22bluered],
    ['s17grayred', iconbutton_s17grayred],
    ['s48whitered', iconbutton_s48whitered],
    ['s44gray4red', iconbutton_s44gray4red],
    ['s36redblue', iconbutton_s36redblue],
    ['s48redred', iconbutton_s48redred],
    ['s32clear', iconbutton_s32clear],
    ['s36black', iconbutton_s36black],
    ['s48outlined', iconbutton_s48outlined],
    ['s48outlinedRed', iconbutton_s48outlinedRed],
    ['s48black', iconbutton_s48black],
  ]);

export const Container = styled.button<{
  isDot: boolean;
  isSelected: boolean;
  isDisabled: boolean;
  lookAndFeel: IconButtonLookAndFeel;
}>`
  width: ${(args) => args.lookAndFeel.buttonSize}px;
  height: ${(args) => args.lookAndFeel.buttonSize}px;

  ${cssFlexRow};
  justify-content: center;
  align-items: center;

  ${
    (args) => {
      if (args.lookAndFeel.borderColor && args.lookAndFeel.selectedBorderColor && args.lookAndFeel.disabledBorderColor) {
        return `
          border: 1px solid ${
            args.isDisabled ? args.lookAndFeel.disabledBorderColor : (args.isSelected ? args.lookAndFeel.selectedBorderColor : args.lookAndFeel.borderColor)
          };
          border-radius: 12px;
        `
      } else {
        return 'border: none;';
      }
    }
  }
  background-color: transparent;
  color: ${
    (args) => args.isDisabled ? args.lookAndFeel.disabledIconColor : (args.isSelected ? args.lookAndFeel.selectedIconColor : args.lookAndFeel.iconColor)};

  padding: 0;

  & svg {
    width: ${(args) => args.lookAndFeel.iconSize};
    height: ${(args) => args.lookAndFeel.iconSize};
  }

  &::after {
    position: absolute;
    content: '';
    right: ${(args) => args.lookAndFeel.dotPadding}px;
    top: ${(args) => args.lookAndFeel.dotPadding}px;
    width: ${(args) => args.lookAndFeel.dotSize}px;
    height: ${(args) => args.lookAndFeel.dotSize}px;
    border-radius: 50%;
  
    background-color: ${(args) => args.lookAndFeel.dotColor};
    opacity: ${(args) => args.isDot ? 100 : 0}%;
  }
`;

export const RippleWrapper = styled.div<{
  lookAndFeel: IconButtonLookAndFeel;
}>`
  width: ${(args) => args.lookAndFeel.buttonSize}px;
  height: ${(args) => args.lookAndFeel.buttonSize}px;
`;
